import { clamp } from '@adaptiva/core/math';
import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Observable, retry, throwError, timer } from 'rxjs';
import { IConnectivityRetryOptions } from '../interfaces';

/**
 * @author Jesse Rogers <jesse.rogers@adaptiva.com>
 * @description HTTP interceptor to catch and retry "unknown error" instances that typically occur due to
 * 	connectivity issues in the user's browser or other non-code-related problems.
 */
export function connectivityInterceptor(): HttpInterceptorFn;
export function connectivityInterceptor(options: Partial<IConnectivityRetryOptions>): HttpInterceptorFn;

export function connectivityInterceptor(_options?: Partial<IConnectivityRetryOptions>): HttpInterceptorFn {
	_options ??= {};
	_options.waitMs ??= 1000;
	_options.waitMultiplier ??= 2;
	_options.maxWaitTime ??= 60 * 1000;
	_options.maxRetries ??= Infinity;

	return (_request: HttpRequest<any>, _handler: HttpHandlerFn): Observable<HttpEvent<any>> => {
		return _handler(_request).pipe(
			retry({
				count: _options.maxRetries,
				resetOnSuccess: false,
				delay: (_error: Error, _retryCount: int) => {
					if (
						_error instanceof HttpErrorResponse &&
						_error.status === 0
					) {
						const _waitTime: int = _options.waitMs * (
							_retryCount > 1
								? (_retryCount - 1) * _options.waitMultiplier
								: _retryCount
						);

						return timer(clamp(_waitTime, 0, _options.maxWaitTime));
					}

					return throwError(() => _error);
				},
			})
		);
	};
}
